import { type FC, memo } from 'react';

export type CloudNetworkInterfaceDetailData = {
  cloudProvider: string | null;
  networkInterfaceId: string | null;
  cloudNetworkId: string | null;
  subnet: string | null;
  description: string | null;
  availabilityZone: string | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudNetworkInterfaceDetailData;
}

const BareCloudNetworkInterfaceDetailContent: FC<Props> = (props) => {
  const isAws = props.tableData.cloudProvider?.toLowerCase() === 'aws';
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>Cloud provider</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudProvider}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Network interface ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.networkInterfaceId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Cloud network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudNetworkId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Subnet</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.subnet}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Description</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.description}
          </td>
        </tr>
        {isAws && (
          <tr>
            <td className={props.firstColumnClassName}>Availability zone</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.availabilityZone}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export const CloudNetworkInterfaceDetailContent = memo(
  BareCloudNetworkInterfaceDetailContent,
);
